module.exports = "/_next/static/images/Frame-cc12d182c1a8bad0c9fb87047a22bcd6.webp";